import { render, staticRenderFns } from "./v-tab.vue?vue&type=template&id=2f90f6d6&"
import script from "./v-tab.vue?vue&type=script&lang=js&"
export * from "./v-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports